<template>
    <CreateServiceReport3></CreateServiceReport3>
</template>
<script>
    import CreateServiceReport3 from '@/components/CreateServiceReport3.vue'
    export default {
        name: 'employee-sign',
        components: {
            CreateServiceReport3
        }
    }
</script>